var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.938,
    height: 8.5,
    viewBox: "0 0 13.938 8.5"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.707 1.537l.83-.83 5.426 5.437L12.4.707l.83.83-6.267 6.26z"
  })));
}
export default SvgDownArrow;